import URL_API from '../../variaveis_globais/const';
import { FormatarDateParaDDMMYYYY } from '../../utils/utils';
import VariaveisGlobais from 'variaveis_globais/variaveis_globais';

const axios = require('axios');
export const getMensagens = function(tipo, dataInicio, dataFim, idEnviadoPara, idEnviadoPor) {
    VariaveisGlobais.token
    let query = `idClinica=${VariaveisGlobais.idClinica}`;
    if (tipo) query += `&tipo=${tipo}`
    if (dataInicio) query += `&dataInicio=${FormatarDateParaDDMMYYYY(dataInicio)}`
    if (dataFim) query += `&dataFim=${FormatarDateParaDDMMYYYY(dataFim)}`
    if (idEnviadoPara) query += `&idEnviadoPara=${idEnviadoPara}`
    if (idEnviadoPor) query += `&idEnviadoPor=${idEnviadoPor}`
    VariaveisGlobais
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}mensagem?${query}`,  {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}


export const pegarClientes = function() {
    let query = `idClinica=${VariaveisGlobais.idClinica}`;

    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}client?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}

export const inicializarInstancia = function (numeroInstancia) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&numeroInstancia=${numeroInstancia}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}instance/init?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data);
        }).catch(function(error) {
            alert(error.response.data.message);
            reject(true);
        });
    });
}

export const qrCodeInstancia = function (numeroInstancia) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&numeroInstancia=${numeroInstancia}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}instance/qr?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data);
        }).catch(function(error) {
            alert(error.response.data.message);
            reject(true);
        });
    });
}

export const estaConectado = function (numeroInstancia) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&numeroInstancia=${numeroInstancia}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}instance/info?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            if (response.data.error == true)  reject(true);
            resolve(response.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}


export const deslogarInstancia = function (numeroInstancia) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&numeroInstancia=${numeroInstancia}`;
    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}instance/logout?${query}`, {
            idClinica: VariaveisGlobais.idClinica
        }, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}

export const pegarConfiguracao = function(tipo) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&nome=${tipo}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}clinica/configuracao?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}

export const salvarMensagemPronta = function(conteudo) {
    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}mensagem/prontas`, {
            idClinica: VariaveisGlobais.idClinica,
            conteudo: conteudo,
        }, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}


export const deletarMensagemPronta = function(id) {
    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}mensagem/prontas/deletar`, {
            idClinica: VariaveisGlobais.idClinica,
            id: id,
        }, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}




export const carregaMensagensProntas = function() {
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}mensagem/prontas?idClinica=${VariaveisGlobais.idClinica}`,{
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}



export const alterarConfiguracao = function(tipo, conteudo) {
    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}clinica/configuracao`, {
            idClinica: VariaveisGlobais.idClinica,
            nome: tipo,
            valor: conteudo
        }, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}

export const salvarConfiguracao = function(tipo, valor) {
    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}clinica/configuracao`, {
            idClinica: VariaveisGlobais.idClinica,
            nome: tipo,
            valor: valor
        }, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}


export const pegarClinicaConfiguracao = function(nome) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&nome=${nome}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}clinica/configuracao?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true)  reject(true);
            resolve(response.data.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}

export const verificarClinicaCadastrada = function() {
    return new Promise(async (resolve, reject) => {
        try {
            // Verificar se existe alguma configuração básica da clínica
            const config = await pegarConfiguracao('CLINICA_CONFIGURADA');
            if (!config) return resolve(false);


            // Se não existe configuração ou valor não é 'true', clínica não está cadastrada
            const cadastrada = config && config.valor === 'true';
            
            // Para demonstração: se for localhost e não tiver configuração, mostrar welcome
            if (window.location.href.includes('localhost') && !cadastrada) {
                resolve(false);
            } else {
                resolve(cadastrada);
            }
        } catch (error) {
            // Se der erro ao buscar configuração, assumir que não está cadastrada
            console.log('Clínica não cadastrada - mostrando página de boas-vindas');
            resolve(false);
        }
    });
}

export const cadastrarClinicaCompleta = function(dadosUrl) {
    const extrairNomeDaString = (str) => {
        if (!str) return 'Clínica';
        return str.replace(/[^a-zA-ZÀ-ÿ\s]/g, '').trim() || 'Clínica';
    };

    return new Promise((resolve, reject) => {
        axios.post(`${URL_API}clinica/cadastro-automatico`, {
            idGsDoctor: dadosUrl.idEmpresa,
            nome: extrairNomeDaString(dadosUrl.usuario),
            token: dadosUrl.token,
            idUsuario: dadosUrl.idUsuario
        }, {
            headers: { Authorization: `Bearer ${dadosUrl.token}` }
        }).then(function (response) {
            if (response.data.error == true) reject(response.data.message);
            resolve(response.data);
        }).catch(function(error) {
            reject(error.response?.data?.message || 'Erro ao criar clínica');
        });
    });
}

export const criarClinicaAutomaticamente = function() {
    return new Promise(async (resolve, reject) => {
        try {
            // Marcar clínica como configurada
            await alterarConfiguracao('CLINICA_CONFIGURADA', 'true');
            
            // Configurar algumas configurações padrão
            await alterarConfiguracao('CLINICA_NOME', 'Minha Clínica');
            await alterarConfiguracao('CLINICA_DATA_CRIACAO', new Date().toISOString());
            
            resolve(true);
        } catch (error) {
            console.error('Erro ao criar clínica:', error);
            reject(error);
        }
    });
}

export const buscarHistoricoInstancia = function(numeroInstancia, limit = 50) {
    let query = `idClinica=${VariaveisGlobais.idClinica}&limit=${limit}`;
    return new Promise((resolve, reject) => {
        axios.get(`${URL_API}clinica/historico/${numeroInstancia}?${query}`, {
            headers: { Authorization: `Bearer ${VariaveisGlobais.token}` }
        }).then(function (response) {
            console.log(response);
            if (response.data.error == true) reject(true);
            resolve(response.data);
        }).catch(function(error) {
            console.log(error);
            reject(true);
        });
    });
}


